import { render } from "./BaseDialogPrompt.vue?vue&type=template&id=4d92e682&scoped=true"
import script from "./BaseDialogPrompt.vue?vue&type=script&lang=js"
export * from "./BaseDialogPrompt.vue?vue&type=script&lang=js"

import "./BaseDialogPrompt.vue?vue&type=style&index=0&id=4d92e682&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d92e682"]])

export default __exports__